import { Bell } from "lucide-react";
import { cn } from "@/utils/cn";

export interface NotificationHeaderBadgeProps {
  unreadCount: number;
  unreadSuffix?: string;
  unreadLabel: string;
  size?: "sm" | "lg";
}

const SIZE_CLASSES = {
  sm: { icon: "h-[26px] w-[26px]", iconSize: 14, title: "text-[14.5px]" },
  lg: { icon: "h-[30px] w-[30px]", iconSize: 16, title: "text-[17px]" },
} as const;

function NotificationHeaderBadge({
  unreadCount,
  unreadSuffix = "",
  unreadLabel,
  size = "sm",
}: NotificationHeaderBadgeProps) {
  const s = SIZE_CLASSES[size];

  return (
    <div className="flex items-center gap-2">
      <span
        className={cn(
          "flex items-center justify-center rounded-lg bg-primary-light text-primary",
          s.icon
        )}
      >
        <Bell size={s.iconSize} />
      </span>
      <span className={cn("font-bold text-text-heading", s.title)}>
        Notifications
      </span>
      {unreadCount > 0 && (
        <span className="rounded-full bg-primary-light px-2 py-px text-[11px] font-bold tabular-nums text-primary">
          {unreadCount}
          {unreadSuffix} {unreadLabel}
        </span>
      )}
    </div>
  );
}

export default NotificationHeaderBadge;
